import { useEffect } from "react";
import { useAuth } from "@/contexts/AuthContext";

/**
 * Mount once (inside AuthProvider) to:
 * 1) Pull+merge data from Supabase after login
 * 2) Auto-push local updates to Supabase (debounced)
 *
 * Anonymous visitors do not need the cloud-sync module at all, so keep it out
 * of the startup path and load it only after a signed-in user is available.
 */
export function CloudSyncGate() {
  const { user, loading } = useAuth();

  useEffect(() => {
    if (loading || !user?.id) return;

    let active = true;
    let detach: (() => void) | undefined;

    void import("@/utils/cloudSync")
      .then(({ attachCloudAutoSync, syncAllFromCloud }) => {
        if (!active) return;

        detach = attachCloudAutoSync();
        return syncAllFromCloud();
      })
      .catch((err) => console.error("[cloudSync] initial sync failed:", err));

    return () => {
      active = false;
      detach?.();
    };
  }, [user?.id, loading]);

  return null;
}
